import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import { EventBB, EventStatus, EventType, AttendeeStatus, EventAttendee } from './event.model';
import { EnumTextValuesPipe } from '../../shared/pipes/enum-keys-text.pipe';
import { EnumKeysPipe } from '../../shared/pipes/enum-keys.pipe';
import { Task } from '../../shared/tasks/task.model';
import { Attachment } from '../../shared/attachments/attachment.model';

@Injectable()
export class EventService implements OnDestroy {

  keepSubscriptionsAlive: boolean = true;

  /* enums for dropdown generation */
  eventStatus = EventStatus;
  eventStatusOptions: any;
  eventStatusDropdownOptions: any;
  eventType = EventType;
  eventTypeOptions: any;
  eventTypeDropdownOptions: any;
  attendeeStatus = AttendeeStatus;
  attendeeStatusOptions: any;

  constructor(private http: HttpClient,
    private enumTextValuesPipe: EnumTextValuesPipe,
    private enumKeyValuesPipe: EnumKeysPipe) { }

  ngOnDestroy() {
    this.keepSubscriptionsAlive = false;
  }

  addTaskToEvent(eventBB: EventBB, task: Task) {

    // create a spoof company and use the id - otherwise we get a json circular reference
    const spoofTask = new Task();
    spoofTask._id = task._id;

    // push the spoofed company to the team member
    eventBB.tasks.unshift(spoofTask);

    // console.log('saving company to teamMember');
    this.saveEvent(eventBB);

  }


  addAttachmentToEvent(eventBB: EventBB, attachment: Attachment) {

    // create a clone and a spoof company and use the id - otherwise we get a json circular reference
    // const clone: Project = _.cloneDeep(company);

    const spoofAttachment = new Attachment();
    spoofAttachment._id = attachment._id;

    // push the spoofed company to the team member
    eventBB.attachments.unshift(spoofAttachment);

    // console.log('saving company to teamMember');
    this.saveEvent(eventBB);

  }

  saveEvent(eventBB: EventBB) {

    this.editEvent(eventBB)
      .takeWhile(() => this.keepSubscriptionsAlive)
      .subscribe(
        res => {
          console.log(res);
        },
        error => {
          console.log(error);
        }
      );
  }

  getEvents(): Observable<EventBB[]> {
    return this.http.get<EventBB[]>('/api/events');
  }

  searchEvents(searchString: string): Observable<EventBB[]> {

    // see https://github.com/surfer77/mongoose-string-query for full API!
    return this.http.get<EventBB[]>('/api/events/search?' + searchString, {
      // params: { ignoreLoadingBar: 'true' }
      headers: { ignoreLoadingBar: '' }
    }).map((events: EventBB[]) => {
      return events;
    }).catch(this.handleError);

  }

  findTopNEvents(searchString: string, limit: number = 5): Observable<EventBB[]> {

    if (searchString === undefined || searchString === '') { searchString = ' '; }

    return this.http.get<EventBB[]>(`/api/events/find/top/${searchString}/${limit}`, {
      headers: { ignoreLoadingBar: '' }
    }).map((events: EventBB[]) => {
      return events;
    }).catch(this.handleError);

  }

  countEvents(): Observable<number> {
    return this.http.get<number>('/api/events/count');
  }

  addEvent(event: EventBB): Observable<EventBB> {
    // console.log(event);
    return this.http.post<EventBB>('/api/event', event);
  }

  getEventFromId(id: string): Observable<EventBB> {
    return this.http.get<EventBB>(`/api/event/${id}`);
  }

  getAttendeesFromEventId(id: string = ' '): Observable<EventAttendee[]> {
    // if (id !== '') {
      return this.http.get<EventAttendee[]>(`/api/event/attendees/${id}`)
        .catch(this.handleError);
    // }
  }


  editEvent(event: EventBB): Observable<string> {
    return this.http.put(`/api/event/${event._id}`, event, { responseType: 'text' });
  }

  deleteEvent(event: EventBB): Observable<string> {
    return this.http.delete(`/api/event/${event._id}`, { responseType: 'text' });
  }

  private handleError(error: Response) {
    return Observable.throw(error.statusText);
  }

  setEventStatusOptions() { this.eventStatusOptions = this.enumTextValuesPipe.transform(this.eventStatus, ['']); }
  setEventTypeOptions() { this.eventTypeOptions = this.enumTextValuesPipe.transform(this.eventType, ['']); }
  setAttendeeStatusOptions() { this.attendeeStatusOptions = this.enumTextValuesPipe.transform(this.attendeeStatus, ['']); }

  setEventStatusDropdownOptions() { this.eventStatusDropdownOptions = this.enumKeyValuesPipe.transform(this.eventStatus, ['']); }
  setEventTypeDropdownOptions() { this.eventTypeDropdownOptions = this.enumKeyValuesPipe.transform(this.eventType, ['']); }

}



// WEBPACK FOOTER //
// ./client/app/features/events/event.service.ts